<app-simple-notification    *ngIf="awaiting"
                            [notificationState]="notificationState"
                            [shouldTranslateMessage]="isMessageTranslated"
                            [loaderVisible]="loaderVisible">
</app-simple-notification>

<div *ngIf="!awaiting"
     class="notification-wrapper__notification">
    <ng-container [ngSwitch]="notificationState.activeNotification">
        <app-positive-notification-web *ngSwitchCase="NotificationComponentKey.PAYMENT_SUCCESS"
                                        [notificationState]="notificationState"></app-positive-notification-web>

        <app-error-notify-section-web *ngSwitchCase="NotificationComponentKey.PAYMENT_ERROR"
                                      [notificationState]="notificationState"></app-error-notify-section-web>

        <app-payment-accept-notification *ngSwitchCase="NotificationComponentKey.PAYMENT_ACCEPT"
                                         [notificationState]="notificationState"></app-payment-accept-notification>

        <app-insurer-data-authorization *ngSwitchCase="NotificationComponentKey.AUTHORIZATION_INSURER_DATA"
                                        [notificationState]="notificationState"></app-insurer-data-authorization>

        <app-insurer-failed-data-authorization *ngSwitchCase="NotificationComponentKey.REGISTRATION_FAILED"
                                               [notificationState]="notificationState"></app-insurer-failed-data-authorization>

        <app-next-success-notification *ngSwitchCase="NotificationComponentKey.NEXT_SUCCESS">
        </app-next-success-notification>
    </ng-container>
</div>

<div *ngIf="otherProductsVisible"
     class="notification-wrapper__other-products">
    <app-other-products></app-other-products>
</div>
